import { useState } from "react";
import Title from "../UI/Title/Title";
import { Tabs, TabsProps, Row, Col } from "antd";
import {
  PieChartTwoTone,
  ShoppingCartOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";

export const GeneralDashboard = () => {
  const [open, setOpen] = useState(true);
  const { t } = useTranslation("common");

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: (
        <span className="summary">
          <PieChartTwoTone style={{ fontSize: "30px", color: "#1677FF" }} />
          <p style={{ color: "#1677FF" }}>{t("general-dashboard")}</p>
        </span>
      ),
    },
    {
      key: "2",
      label: (
        <div className="Purchases">
          <ShoppingCartOutlined
            style={{ fontSize: "30px", color: "#1677FF" }}
          />
          <p style={{ color: "#1677FF" }}>Purchase history</p>
        </div>
      ),
      forceRender: true,
    },
    {
      key: "3",
      label: (
        <div className="Purchases">
          <ShoppingCartOutlined
            style={{ fontSize: "30px", color: "#1677FF" }}
          />
          <p style={{ color: "#1677FF" }}>Purchase history</p>
        </div>
      ),
      forceRender: true,
    },
  ];

  return (
    <>
      <Row>
        <Col offset={1} span={12}>
          <Row>
            <Title title=" General Dashboard/" />
          </Row>
        </Col>
        <Col offset={5}>
          {/* <Search /> */}
        </Col>
      </Row>
      <Row gutter={[15, 0]} style={{ marginTop: "30px" }}>
        <Col offset={1}>
          {open ? (
            <DoubleLeftOutlined
              onClick={() => setOpen((old) => !old)}
              style={{ fontSize: "30px", color: "#162149" }}
            />
          ) : (
            <DoubleRightOutlined
              onClick={() => setOpen((old) => !old)}
              style={{ fontSize: "30px", color: "#162149" }}
            />
          )}
        </Col>
      </Row>

      <Row>
        <Col>
          <Tabs
            style={{ marginTop: "20px" }}
            className="left-tab"
            tabBarStyle={open ? { height: "100vh" } : { display: "none" }}
            defaultActiveKey="1"
            items={items}
            tabPosition="left"
            // onChange={onChange}
          />
        </Col>
        <Col offset={1} span={20}>
          {/* <PurchList />  */}
        </Col>
      </Row>
    </>
  );
};
